/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

export default function SizeSoftXBody(props) {
    return (
        <div className="work-area" style={{ padding: !props.padding ? 0 : props.padding }}>
            {props.children}
        </div>
    );
}
